import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { Analytics } from "@vercel/analytics/react"
import App from './App';
import './index.css';

function Telemetry() {
  const location = useLocation();
  return location.pathname === '/invite' ? null : <><SpeedInsights /><Analytics /></>;
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: `${window.location.origin}/login`,
      }}
    >
      <BrowserRouter>
        <Telemetry />
        <App />
      </BrowserRouter>
    </Auth0Provider>
  </React.StrictMode>
);
